import { apiBff } from '@/api'

export async function getSeasons<T>(): Promise<T> {
  return apiBff.callBFF<T>('GET', 'seasons')
}
